import logger from '../../../utils/logger';
import { Material } from '../../../../types/api/Material';
import { Device } from '../../../../types/api/Device';
import { timerKey } from '../../../utils/timer-manager/timer-manager';

export const stopOriginalBin = (batchStore: any, originalBin: Device, originalMaterial: Material, scale: Device) => {
  if (!originalBin) return;

  if (originalBin.gateOnePNo && batchStore.isOutputOn(originalBin.gateOnePNo)) {
    batchStore.setOutput(originalBin.gateOnePNo, '0');
    logger.log('Closed original bin gate:', originalBin.id, originalBin.description);
  }

  batchStore.stopAttachedDevices(originalBin.id);

  batchStore.timers.clear(timerKey.device(originalBin.id));
  batchStore.timers.clear(timerKey.batchMaterial(originalMaterial.itemId));
  batchStore.timers.clear(timerKey.device(scale.id));
  batchStore.timers.clear(timerKey.scaleWeight(scale.id));
  batchStore.timers.clear(timerKey.checkFinalWeight(originalMaterial.itemId));

  if (batchStore.finishFeedDevices.includes(originalBin.id)) {
    batchStore.finishFeedDevices = batchStore.finishFeedDevices.filter((id: any) => id !== originalBin.id);
  }
};

export const handleDeferredWeights = (batchStore: any, scaleId: string, originalBins: Device[], substituteBins: Device[]): number => {
  const deferredBins: Map<number, number> | undefined = batchStore.deferredFeedDevices.get(Number(scaleId));
  if (!deferredBins) {
    return 0;
  }

  const weights = originalBins.map(bin => deferredBins.get(bin.id) || 0);
  originalBins.forEach(bin => deferredBins.delete(bin.id));

  weights.forEach((weight, index) => {
    if (weight) {
      const substituteBin = substituteBins[index] || substituteBins[0];
      deferredBins.set(substituteBin.id, (deferredBins.get(substituteBin.id) || 0) + weight);
      logger.log('Transferred deferred weight from bin', originalBins[index].id, 'to bin', substituteBin.id, 'weight:', weight);
    }
  });

  return weights.reduce((total, weight) => total + weight, 0);
};
